import { UseFormReturnType } from '@mantine/form'
import ModalSelect from '@v2/commons/components/ModalSelect/modalSelect.component'

import {
  MutateEscalationData,
  NON_BENEFIT_OPTIONS,
} from '../../escalation.types'

interface NonBenefitSectionForm {
  form: UseFormReturnType<MutateEscalationData>
}

const NonBenefitSection = ({ form }: NonBenefitSectionForm) => {
  return (
    <>
      <ModalSelect
        options={NON_BENEFIT_OPTIONS}
        label="Issue"
        required
        placeholder="Select issue"
        {...form.getInputProps('issue')}
      />
    </>
  )
}

export default NonBenefitSection
